import { render, staticRenderFns } from "./ProfileFreelancer.vue?vue&type=template&id=4c869b63&scoped=true&"
import script from "./ProfileFreelancer.vue?vue&type=script&lang=js&"
export * from "./ProfileFreelancer.vue?vue&type=script&lang=js&"
import style0 from "./ProfileFreelancer.vue?vue&type=style&index=0&id=4c869b63&prod&scoped=true&lang=css&"
import style1 from "./ProfileFreelancer.vue?vue&type=style&index=1&id=4c869b63&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c869b63",
  null
  
)

export default component.exports